import {extendObservable, reaction} from 'mobx';
import {Exclude, Expose, classToPlain} from "class-transformer";
import {simplyDeserialize} from "../../serialization/common";
import {safeMomentDate} from "../functions";
import {FILE_SOURCES} from "../constants";

@Exclude()
export default class Attachment{

    constructor(store, id, persisted = true, attachmentData = undefined) {
        this.store = store;
        extendObservable(this, {
            @Expose()
            id: id,

            attachmentUrl: undefined,

            attachmentName: undefined,

            externalLink: undefined,

            creator: {},

            @Expose()
            hidePreview: false,

            createdAt: undefined,

            updatedAt: undefined,

            attachable: {},

            persisted: persisted && !attachmentData,

        });

        this.attachmentData = attachmentData;

        this.autoUpdate = true;
        // Automatically update in backend when there is any change in
        // the tracked data
        this.updateDisposer = reaction( () => {
                const trackedData = {
                    hidePreview: this.hidePreview,
                };
                return trackedData;
            },
            () => {
                if( this.persisted && this.autoUpdate ){
                    if( this.store ){
                        this.store.updateBackend(this);
                    }
                }
            });
    }

    serialize(){
        let basicSerialize = classToPlain(this);
        return basicSerialize;
    }

    toJson(){
        return this.serialize();
    }

    isExternal(){
        return this.externalLink != undefined;
    }

    get url(){
        return this.isExternal() ? this.externalLink : this.attachmentUrl;
    }

    hasThumbnail(){
        return !this.isExternal() && this.attachmentName.match(/.(jpg|jpeg|png|gif)$/i);
    }

    get source(){
        if( this.isExternal() ){
            if( this.externalLink.match(/google/)){
                return FILE_SOURCES.GOOGLE;
            }
            else if( this.externalLink.match(/dropbox/ ) ){
                return FILE_SOURCES.DROPBOX;
            }
            else if( this.externalLink.match(/box/) ){
                return FILE_SOURCES.BOX;
            }
            throw "InvalidSourceException";
        }
        throw "SourceInNonExternalAttachmentException";
    }

    static deserialize(json, attachable, store){
        let result = simplyDeserialize(Attachment, json);
        result["createdAt"] = safeMomentDate(json.createdAt);
        result["updatedAt"] = safeMomentDate(json.updatedAt);
        result.attachable = attachable;
        result.store = store;
        result.id = json.id;
        result.creator = json.creator;
        if( !attachable.attachments ){
            attachable.attachments = []
        }
        attachable.attachments.push(result);
        return result;
    }

    persist(){
        this.store.createBackend(this);
        this.attachable.attachments.push(this);
    }

    destroy(){
        this.store.destroy(this);
        this.dispose();
    }

    dispose(){
        this.updateDisposer();
        this.attachable.attachments.remove(this);
    }

    toggleHidePreview(){
        this.hidePreview = !this.hidePreview;
    }

}

// Attributes to be included in deserialization and copies
// See common_components/serialization/common.js
Attachment.allowedInstanceProperties = ['id', 'attachmentUrl', 'attachmentName', 'externalLink', 'creator',
    'hidePreview', 'createdAt', 'updatedAt'];